import { Icon } from "@iconify/react";
import { motion } from "framer-motion";

export function Footer({
    copyright,
    logo,
    links,
    social,
    description = "",
    ...rest
}) {
    const col1Links = links.filter((l) =>
        ["FITUR", "PAKET", "TESTIMONI"].includes(l.label),
    );
    const col2Links = links.filter((l) =>
        ["FAQs", "KONTAK"].includes(l.label),
    );

    const linkClass =
        "text-sm font-medium text-title dark:text-base-300 hover:text-cyan-500 dark:hover:text-cyan-400 transition-colors";
    const socialClass =
        "text-muted dark:text-base-400 hover:text-cyan-500 dark:hover:text-cyan-400 transition-colors";
    const fadeUp = (delay) => ({
        initial: { opacity: 0, y: 20 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true },
        transition: { duration: 0.5, delay, ease: "easeOut" },
    });

    return (
        <footer
            className="bg-gradient-to-b from-white via-cyan-50/40 to-cyan-100/60 dark:bg-base-950 pt-16 pb-8"
            {...rest}
        >
            <div className="container max-w-6xl px-4 sm:px-6 lg:px-8 mx-auto">
                <div className="flex flex-col md:grid md:grid-cols-12 gap-8 mb-16">
                    {/* Logo + description */}
                    <motion.div
                        {...fadeUp(0)}
                        className="md:col-span-5 flex flex-col items-start gap-4"
                    >
                        <img
                            src={logo.src}
                            alt={logo.alt}
                            className="h-10 w-auto dark:invert"
                        />
                        <p className="text-muted dark:text-base-400 text-sm max-w-sm leading-relaxed">
                            {description ||
                                "Antrian klinik digital yang membantu mempermudah pengelolaan antrian pasien agar pelayanan kesehatan menjadi lebih tertib, cepat, dan nyaman."}
                        </p>
                    </motion.div>

                    {/* Links — selalu 2 kolom */}
                    <motion.div
                        {...fadeUp(0.1)}
                        className="md:col-span-4 grid grid-cols-2 gap-x-8"
                    >
                        <ul className="flex flex-col gap-4">
                            {col1Links.map((link, index) => (
                                <li key={index}>
                                    <a href={link.href} className={linkClass}>
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                        <ul className="flex flex-col gap-4">
                            {col2Links.map((link, index) => (
                                <li key={index}>
                                    <a href={link.href} className={linkClass}>
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </motion.div>

                    {/* Social icons */}
                    <motion.div
                        {...fadeUp(0.3)}
                        className="md:col-span-3 flex md:justify-end items-start"
                    >
                        <div className="flex gap-4">
                            {social.map((item, index) => (
                                <a
                                    key={index}
                                    href={item.url}
                                    className={socialClass}
                                >
                                    <Icon
                                        icon={item.icon}
                                        width="22"
                                        height="22"
                                    />
                                </a>
                            ))}
                        </div>
                    </motion.div>
                </div>

                <motion.div
                    {...fadeUp(0.4)}
                    className="border-t border-base-200 dark:border-base-800 pt-8 text-center"
                >
                    <p className="text-muted dark:text-base-500 text-sm">
                        {copyright}
                    </p>
                </motion.div>
            </div>
        </footer>
    );
}
